import { render, staticRenderFns } from "./FacebookLikeBox.vue?vue&type=template&id=7d0be717&scoped=true&"
import script from "./FacebookLikeBox.vue?vue&type=script&lang=js&"
export * from "./FacebookLikeBox.vue?vue&type=script&lang=js&"
import style0 from "./FacebookLikeBox.vue?vue&type=style&index=0&id=7d0be717&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0be717",
  null
  
)

export default component.exports